export default "__VITE_ASSET__78a9e789__"